import React from 'react';

const StatusBadge = ({ status }) => {
  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'available':
        return 'bg-green-100 text-green-800 border-green-200';
      case 'off site':
      case 'offsite':
        return 'bg-orange-100 text-orange-800 border-orange-200';
      case 'preorder':
        return 'bg-blue-100 text-blue-800 border-blue-200';
      default:
        return 'bg-gray-100 text-gray-600 border-gray-200';
    }
  };

  const getStatusIcon = (status) => {
    switch (status?.toLowerCase()) {
      case 'available':
        return '✅';
      case 'off site':
      case 'offsite':
        return '📦';
      case 'preorder':
        return '🔄';
      default:
        return '⚪';
    }
  };

  if (!status) return null;

  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium border ${getStatusColor(
        status
      )}`}>
      <span>{getStatusIcon(status)}</span>
      <span>{status}</span>
    </span>
  );
};

export default React.memo(StatusBadge);